import axiox from 'axios'
import { ResponseData } from './response'
import { User } from './user'

export class Urls {
  static base_url = process.env.VUE_APP_URL;
  static login_url = '/password'
  static detail_sales = '/detail/sales'
  static detail_compare = '/detail/compare'
  static home_upload = '/upload'
  static home_download = '/download'
  static stock_bind = '/bind'
  static home_info = '/info'
  static home_important = '/set/focus'
}

export class Http {
  static post<T> (url: string, data: any, contentType = 'application/json'): Promise<T> {
    this.setHeaderInfo(contentType)
    const postUrl = Urls.base_url + url
    return new Promise((resolve, reject) => {
      axiox.post<ResponseData>(postUrl, data).then((axioxRes) => {
        const res: ResponseData = axioxRes.data
        if (res.Code === 0) {
          resolve(res.Data)
        } else {
          reject(res)
        }
      }, res => {
        reject(res)
      })
    })
  }

  static get<T> (url: string): Promise<T> {
    this.setHeaderInfo()
    const getUrl = Urls.base_url + url
    return new Promise((resolve, reject) => {
      axiox.get<ResponseData>(getUrl).then((axioxRes) => {
        const res: ResponseData = axioxRes.data
        if (res.Code === 0) {
          resolve(res.Data)
        } else {
          reject(res)
        }
      }, res => {
        reject(res)
      })
    })
  }

  static setHeaderInfo (contentType = 'application/json') {
    axiox.defaults.headers.common.Authorization = 'token ' + User.get()
    axiox.defaults.headers.post['Content-Type'] = contentType
  }
}
